import { VideoUpload } from '@/components/form';
import { Input } from '@/components/ui/input';
import VideoPlaceholder from './VideoPlaceholder';

interface VideoProps {
  value: string;
  onChange: (value: string) => void;
  onFocus?: (id: string, value: string) => void;
  id: string;
  placeholder?: string;
}

function Video({ value, onChange, onFocus, id, placeholder }: VideoProps) {
  const handleFocus = () => {
    onFocus?.(id, value || '');
  };

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        {value ? (
          <video className="h-auto w-40 rounded" src={value} controls muted />
        ) : (
          <VideoPlaceholder />
        )}
        <div className="flex flex-grow flex-col gap-2">
          <Input
            placeholder={placeholder || 'Enter video URL'}
            id={id}
            value={value}
            onChange={(e) => onChange?.(e.target.value)}
            onFocus={handleFocus}
          />
          <VideoUpload url={value} onVideoAvailable={(url) => onChange?.(url)} onFocus={handleFocus} />
        </div>
      </div>
    </div>
  );
}

export default Video;
